import React, { useCallback } from 'react';
import { set, startCase } from 'lodash/fp';

import { AddressForNotice } from '../../../../datasets/store/mlTypes';
import { Text } from '../../../../shared/text/Text';
import styles from './FewShotDocumentAnalysis.module.scss';
import { PlusButton } from '../../../../shared/button/PlusButton';
import { DeleteButton } from '../../../../shared/button/DeleteButton';

const orderedKeys: Array<keyof AddressForNotice> = ['attention', 'address', 'telephoneNumber', 'faxNumber', 'email'];

interface AddressForNoticesProps {
    value: AddressForNotice[];
    updateValue: (value: AddressForNotice[]) => void;
}

export const AddressForNotices: React.FC<AddressForNoticesProps> = ({ value, updateValue }) => {
    const updateAddressValue = useCallback((index: number, key: keyof AddressForNotice, addressValue: string) => {
        const updatedValue = value.map((address, i) => i === index ? set(key, addressValue, address) : address);
        updateValue(updatedValue);
    }, [value, updateValue]);

    const removeAddress = useCallback((index: number) => {
        const updatedValue = value.filter((_, i) => i !== index);
        updateValue(updatedValue);
    }, [value, updateValue]);

    const addAddress = useCallback(() => {
        const updatedValue = [...value, { attention: '', address: '', telephoneNumber: '', faxNumber: '', email: '' }];
        updateValue(updatedValue);
    }, [value, updateValue]);

    return (
        <div className={styles.addressForNoticesWrapper}>
            {value.map((address, index) => (
                <div key={index} className={styles.addressWrapper}>
                    <div className={styles.address}>
                        {orderedKeys.map(key => (
                            <div key={key} className={styles.addressElementWrapper}>
                                <div className={styles.addressLabel}>{startCase(key)}</div>
                                <div className={styles.addressValue}>
                                    <Text
                                        value={address[key] || ''}
                                        onChange={e => updateAddressValue(index, key, e.currentTarget.value)}
                                        testId={`address-for-notice-${index}-${key}`}
                                        marginBottom='0px'
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                    <DeleteButton onClick={() => removeAddress(index)} fontSize={20} />
                </div>
            ))}
            <div className={styles.addNewAddress}>
                <PlusButton onClick={addAddress} fontSize={18} />
                <div className={styles.addNewAddressLabel}>Add Address</div>
            </div>
        </div>
    );
};
